import React from 'react'
import styled from 'styled-components'
import { ReqColumnWithMetaData, ReqWithMetaData } from '../types'
import { SelectFormItem } from './SelectFormItem'
import { BaseLabel } from './BaseLabel'
import { FieldTypeEnum } from 'packages/sdks-next/growp'
import { Form } from '@seiue/ui'
import { customizeCountValidator } from 'packages/utils'
import { normFile } from './utils'

/**
 * 问卷 - 表单项
 *
 * @param param - 参数
 * @param param.currentIndex - 当前题目序号
 * @returns React.ReactNode
 */
export const BaseFormItem: React.FC<{
  currentIndex: number
  currentQuestion: ReqWithMetaData | ReqColumnWithMetaData
}> = ({ currentIndex, currentQuestion }) => {
  const { require, label, description, metadata, type, index, isUserField } =
    currentQuestion
  const { minCount, maxCount } = metadata || {}
  return (
    <Wrapper>
      {[FieldTypeEnum.Describe, FieldTypeEnum.PageBreak].includes(
        type
      ) ? null : (
        <>
          <BaseLabel
            type={type}
            label={label || ''}
            require={require}
            metadata={metadata || {}}
            currentIndex={index || currentIndex}
          />
          {description && (metadata?.showDescription || isUserField) ? (
            <Description>{description}</Description>
          ) : null}
        </>
      )}
      <ComponentWrapper>
        <Form.Item
          name={
            currentQuestion.type !== FieldTypeEnum.Product
              ? currentQuestion.name || `pv-${currentQuestion.index}`
              : undefined
          }
          rules={[
            {
              required: !!require,
              message: '此项为必填项',
            },
            {
              validator: (rule, value, callback) =>
                customizeCountValidator(
                  rule,
                  value,
                  callback,
                  {
                    max: maxCount,
                    min: minCount,
                    type: type,
                  },
                  true
                ),
            },
          ]}
          valuePropName={
            currentQuestion.type === FieldTypeEnum.Attachment
              ? 'fileList'
              : undefined
          }
          getValueFromEvent={
            currentQuestion.type === FieldTypeEnum.Attachment
              ? normFile
              : undefined
          }
        >
          <SelectFormItem
            currentQuestion={currentQuestion}
            currentIndex={currentIndex}
          />
        </Form.Item>
      </ComponentWrapper>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  width: 100%;
  padding: 20px 40px 20px 0;
`

const Description = styled.div`
  margin-bottom: 12px;
  padding-left: 40px;
  font-size: 14px;
  color: ${(props) => props.theme.text._2};
`

const ComponentWrapper = styled.div`
  padding-left: 40px;
`
